import Springlake1 from "../../media/logo/springlake.webp";
import Springlake2 from "../../media/logospringlake.png";

const springlakeimages = [Springlake1, Springlake2];

export default springlakeimages;
